/** Mirror of sparepe_backend/src/constants/garagePackageServices.js */

export const PACKAGE_SERVICE_IDS = Object.freeze([
  'periodic_package_10k',
  'periodic_package_20k',
  'periodic_package_40k',
  'periodic_package_60k',
  'periodic_package_80k',
  'amc_subscription',
  'seasonal_package',
  'fleet_maintenance',
]);

export const PACKAGE_SERVICES = Object.freeze([
  { serviceId: 'periodic_package_10k', label: '10,000 km Periodic Service Package', packageEligible: true },
  { serviceId: 'periodic_package_20k', label: '20,000 km Periodic Service Package', packageEligible: true },
  { serviceId: 'periodic_package_40k', label: '40,000 km Periodic Service Package', packageEligible: true },
  { serviceId: 'periodic_package_60k', label: '60,000 km Periodic Service Package', packageEligible: true },
  { serviceId: 'periodic_package_80k', label: '80,000 km Periodic Service Package', packageEligible: true },
  { serviceId: 'amc_subscription', label: 'Annual Maintenance Contract (AMC)', packageEligible: true },
  { serviceId: 'seasonal_package', label: 'Seasonal Package (Monsoon/Summer/Winter)', packageEligible: true },
  { serviceId: 'fleet_maintenance', label: 'Fleet Maintenance Plan', packageEligible: true, largeOnly: true },
]);

export const PACKAGE_ELIGIBLE_TIERS = Object.freeze(['medium', 'large']);

export function isPackageEligibleTier(tier) {
  const canonical = String(tier || '').trim().toLowerCase();
  return PACKAGE_ELIGIBLE_TIERS.includes(canonical);
}

export function isPackageServiceId(serviceId) {
  return PACKAGE_SERVICE_IDS.includes(String(serviceId || '').trim());
}

export function getPackageServicesForTier(tier) {
  const canonical = String(tier || '').trim().toLowerCase();
  if (!isPackageEligibleTier(canonical)) return [];
  return PACKAGE_SERVICES.filter((s) => !s.largeOnly || canonical === 'large');
}
